import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdatePushReportRecipientForUserMutation } from "org/user/queries/useUpdatePushReportRecipientForUserMutation";

import { PushReportRecipientRow } from "./useUserPushReportsRecipientListTable";

interface UseRemovePushReportRecipientUtilsProps {
    userId: number;
    selectedRows: Row<PushReportRecipientRow>[];
    deselectAll: () => void;
}

export function useRemovePushReportRecipientUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseRemovePushReportRecipientUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdatePushReportRecipientForUserMutation();

    const removeUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const removeUser = async () => {
        const pushReportConfigurationIds = selectedRows.map(
            (row) => row.original.id
        );
        try {
            await mutateAsync({
                userId,
                data: { newUserId: null, pushReportConfigurationIds },
            });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        removeUserToolState,
        isRemoveUserModalOpen: isModalOpen,
        openRemoveUserModal: () => setIsModalOpen(true),
        closeRemoveUserModal: () => setIsModalOpen(false),
        removeUser,
        isRemovingUser: isPending,
    };
}
